
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, OnDestroy } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { CoreLanguageService } from "../../services/language.service";
import { CoreLogService } from "../../services/log.service";
import { CountryCodes, Country_DE, Country_EN, PhoneNumberInputService } from "./phoneNumberInput.service";
import { WebShopService } from "../../services/webShop.service";
import { ValidatorsConfig } from "../../shared/validator/validator.function";

@Component({
  selector: "ya-phone-number-input",
  templateUrl: "./phoneNumberInput.component.html",
  styleUrls: ["./phoneNumberInput.component.scss"],
  providers: [PhoneNumberInputService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class PhoneNumberInputComponent implements OnInit, OnDestroy {
  private _inputSubscriber: Subscription;
  private _inputValidationSubscriber: Subscription;
  /** template */
  public numberTemplate: string = "123456789"
  /** list of countrieswith codee */
  public countryData: CountryCodes[];
  /** selected country code */
  public selectedCode: string;
  /** input number(phone number) */
  public inputNumber: string;
  /** input controls */
  public inputFormControl = new FormControl('', {
    validators: ValidatorsConfig.forPhoneNumber(),
  });

  constructor(private _iosHelperService: IOSHelperService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _phoneNumberInputService: PhoneNumberInputService
    , private _webshopService: WebShopService
  ) {

  }
  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("PhoneNumberInputComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.setCountryData();
    me.setDefaultCountryCodeOnload();
    /** get latest validation status of that control whenever validation status is recalculated for that control. */
    me._inputValidationSubscriber = me.inputFormControl.statusChanges.subscribe((val) => {
      me.PushChanges();
    });

    /** get latest value of that control whenever there is any change. */
    me._inputSubscriber = me.inputFormControl.valueChanges.subscribe(() => {
      me.inputNumber = me.inputFormControl.value;
      me.inputFormControl.markAsTouched();
      me.PushChanges();
    });
  }

  /** set country list check selected language */
  public setCountryData() {
    const me = this;
    if (me._coreLanguageService.getCurrentLanguage() === "de") {
      return me.countryData = Country_DE;
    } else if (me._coreLanguageService.getCurrentLanguage() === "en") {
      return me.countryData = Country_EN;
    }
    me.PushChanges();
  }

  /** selected code changed */
  public SelectCodeChangeHandler(event: any) {
    const me = this;
    me.selectedCode = event.target.value;
    const selectedCountry = me.countryData.find(i => i.data_code === me.selectedCode);
    if (selectedCountry) {
      me.selectedCode = selectedCountry.data_code;
    }
  }

  /** selected country code*/
  public async setDefaultCountryCodeOnload() {
    const me = this;
    me.selectedCode = await me.getDefaultCountryCode();
    me.PushChanges();
  }

  /**
 * Determines the default country code based on the first three characters of a phone number.
 * If no match is found within the first three elements of the provided country list,
 * the function defaults to Germany (+49).
 * 
 * @param phoneNumber - The phone number to check.
 * @param countryList - The list of country codes to compare against.
 * @returns The matching country code or the default (+49) if no match is found.
 */
  private async getDefaultCountryCode(): Promise<string> {
    const phoneNumber = await this._webshopService.getLocationPhoneNumber();
    const DEFAULT_COUNTRY_CODE = "+49";
    if (phoneNumber) {
      // Check if the phone number starts with "+"
      if (!phoneNumber.startsWith("+")) {
        return DEFAULT_COUNTRY_CODE;
      }
      const prefix = phoneNumber.substring(0, 3);
      // Loop through only the first three elements of the country list
      for (let i = 0; i < 3; i++) {
        if (this.countryData[i].data_code === prefix) {
          return this.countryData[i].data_code;
        }
      }
    }

    return DEFAULT_COUNTRY_CODE;
  }


  /** phone number with country code
   * remove leading zero, remove white space */
  public get PhoneNumber(): string {
    const me = this;
    return me.selectedCode.concat(me.inputNumber.replace(/\D|^0+/g, "")).trim();
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._inputSubscriber) {
      me._inputSubscriber.unsubscribe()
    }
    if (me._inputValidationSubscriber) {
      me._inputValidationSubscriber.unsubscribe()
    }
  }
}